module.exports = __webpack_public_path__ + "static/img/entrance3.ba140a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/fcsw/entrance3.jpg
// module id = y2IF
// module chunks = 1